import React from 'react';
import FineUploaderTraditional from 'fine-uploader-wrappers';
import Gallery from 'react-fine-uploader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import 'react-fine-uploader/gallery/gallery.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

const statusText = {
  upload_successful: 'Baigta',
  canceled: 'Atšaukta',
  deleting: 'Trinama...',
  paused: 'Pristabdyta',
  queued: 'Laukiama',
  retrying_upload: 'Bandoma iš naujo...',
  submitting: 'Įkeliama...',
  uploading: 'Apdorojama...',
  upload_failed: 'Įvyko klaida',
};

class FileUpload extends React.Component {
  notify = () => toast.error('Galite įkelti failą nedidesnį nei 500kB', {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 3000
  });

  uploader = new FineUploaderTraditional({
    options: {
      chunking: {
        enabled: true
      },
      request: {
        endpoint: '/api/tag/mwe'
      },
      retry: {
        enableAuto: false
      },
      callbacks: {
        onComplete: (id, name, response) => this.props.saveResults(id, name, response),
        onValidate: (obj) => this.validate(obj),
      }
    }
  });

  validate(obj) {
    toast.dismiss();
    const valid = obj.size && obj.size < 500000;

    if (!valid) {
      this.notify();
    }

    return valid;
  }

  render() {
    const dropzoneChildren = <span className="react-fine-uploader-gallery-dropzone-content">
    Įkelkite failus</span>;

    const fileInputChildren = <div className="velgFilInnhold">
      <FontAwesomeIcon size="sm" icon={faCloudUploadAlt}/> Įkelti
    </div>;

    return (
      <div className="m-2">
        <Gallery
          status-text={statusText}
          dropzone-style={{ borderColor: 'lightgrey' }}
          fileInput-children={fileInputChildren}
          fileInput-accept=".txt"
          children={dropzoneChildren}
          uploader={this.uploader}
        />
        <ToastContainer/>
      </div>
    );
  }
}

export default FileUpload;

